import React from 'react'
import {connect} from 'react-redux'
import {reset_axios} from '../services'
import { parentUrl } from "../constants"

import {
  logoutUser,
  validateToken
} from '../actions'

const mapStateToProps = state => {
  return {

  }
}

const mapDispatchToProps = dispatch => {
  return {
    logoutUser: () => dispatch( logoutUser() ),
    validateToken: () => dispatch( validateToken() )
  }
}

class ConnectedFrame extends React.Component {

  receiveMessage(event) {
    // console.log("b2b")
    // console.log(event)
    const { logoutUser, validateToken } = this.props
    if ( event.origin !== parentUrl ) {
      return
    }
    const {data} = event
    if ( data && data === "/registration_step1_success" ) {
          // ReactGA.pageview('/registration_step1_success')
          // window.dataLayer.push({
          //   'event': 'VirtualPageview',
          //   'virtualPageURL': '/registration_step1_success',
          //   'virtualPageTitle': 'Registration Step 1 Success'
          // })
          // FP.trackCustom( 'ProspectGenerated' )
    } else if ( data &&  data === "/registration_step2_success" ) {
          // ReactGA.pageview('/registration_step2_success')
          // window.dataLayer.push({
          //   'event': 'VirtualPageview',
          //   'virtualPageURL': '/registration_step2_success',
          //   'virtualPageTitle': 'Registration Step 2 Success'
          // })
          // FP.track( 'CompleteRegistration' )
    } else if ( data &&  data === "/login" ) {
          // ReactGA.pageview("/login")
          // window.dataLayer.push({
          //   'event': 'VirtualPageview',
          //   'virtualPageURL': '/login',
          //   'virtualPageTitle': 'Successful Sign In'
          // })
          // FP.trackCustom( 'Login' )
    } else if (data && data!=='logout' && data.length > 10) {
      localStorage.setItem('userdata', data)
      reset_axios()
      setTimeout(validateToken(), 300)

    } else if (data === 'logout') {
      localStorage.removeItem('userdata')
      setTimeout( function() {
        // No logout during dropin
        const newTrial = JSON.parse( localStorage.getItem('userdata') ) || false
        if (! newTrial ) {
          logoutUser()
        }
      }, 250)
    }
  }

  componentWillMount() {
    window.addEventListener("message", this.receiveMessage.bind(this), true);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.receiveMessage.bind(this), false);
  }

  render() {
    return (
      <span>Hello interactivity</span>
    )
  }
}

const Frame = connect(mapStateToProps, mapDispatchToProps)(ConnectedFrame)
export default Frame



// WEBPACK FOOTER //
// ./src/js/components/Frame.js